function sideEffectOnContrastChange(contrast) {
	const logo = document.querySelector('.header__container-top-logo > img');
	const contrastBtn = document.querySelector('.contrast-btn > img');

	if (contrast) {
		document.body.classList.add('contrast');

		logo.setAttribute('src', logo.getAttribute('src').replace('logo.png', 'logo_contrast.png'));

		contrastBtn.setAttribute(
			'src',
			contrastBtn.getAttribute('src').replace('contrast.png', 'contrast_contrast.png')
		);
	} else {
		document.body.classList.remove('contrast');

		logo.setAttribute('src', logo.getAttribute('src').replace('logo_contrast.png', 'logo.png'));

		contrastBtn.setAttribute(
			'src',
			contrastBtn.getAttribute('src').replace('contrast_contrast.png', 'contrast.png')
		);
	}
}

// Change font size
const fonts = {
	small: '50%',
	normal: '62.5%',
	big: '100%',
};

if (localStorage.getItem('contrast') === 'true') {
	document.body.classList.add('contrast');

	sideEffectOnContrastChange(true);
}
const fontsize = localStorage.getItem('fontsize');
if (fontsize) {
	document.querySelector('html').style.setProperty('font-size', fonts[fontsize]);
}

document.querySelectorAll('.font-size-btn').forEach((item) => {
	item.addEventListener('click', function (e) {
		const type = e.target.getAttribute('data-fontsize');
		localStorage.setItem('fontsize', type);
		document.querySelector('html').style.setProperty('font-size', fonts[type]);
	});
});

// Change contrast
document.querySelectorAll('.contrast-btn').forEach((item) => {
	item.addEventListener('click', function () {
		if (document.body.classList.contains('contrast')) {
			document.body.classList.remove('contrast');
			localStorage.removeItem('contrast');

			sideEffectOnContrastChange(false);
		} else {
			document.body.classList.add('contrast');
			localStorage.setItem('contrast', 'true');

			sideEffectOnContrastChange(true);
		}
	});
});

document.addEventListener('DOMContentLoaded', function () {
	const nav = document.querySelector('.header__container-navigation');
	const toggler = document.querySelector('.header__container-top-navbar-toggler');
	const mobileBreakpoint = 768;

	function handleMenuDisplay() {
		if (window.innerWidth < mobileBreakpoint) {
			nav.style.display = 'none';
			toggler.style.display = 'flex';
		} else {
			nav.style.display = '';
			toggler.style.display = 'none';
			toggler.setAttribute('aria-expanded', 'false');
		}
	}

	toggler.addEventListener('click', function () {
		if (nav.style.display === '' || nav.style.display === 'flex') {
			nav.style.display = 'none';
			toggler.setAttribute('aria-expanded', 'false');
		} else {
			nav.style.display = 'flex';
			toggler.setAttribute('aria-expanded', 'true');
		}
	});

	handleMenuDisplay();
	window.addEventListener('resize', handleMenuDisplay);
});

window.addEventListener('load', function() {
	window.scrollTo(0, 0);
});

const oldScrollIntoView = Element.prototype.scrollIntoView.bind(Element.prototype);
Element.prototype.scrollIntoView = function (options) {
	if (this.id === 'main-content') {
		return;
	}

	oldScrollIntoView.call(this, options);
};
